import React from "react";
import DesktopNav from "./DesktopNav";
import MobileNav from "./MobileNav";
import { useViewport } from "utils/context";
import { NavContextProvider } from "utils/context/nav";

const Nav = () => {
  const { isDesktop } = useViewport();

  return (
    <NavContextProvider>
      <div className="w-100">
        {isDesktop ? (
          <DesktopNav key="desktopNav" />
        ) : (
          <MobileNav key="mobileNav" />
        )}
      </div>
    </NavContextProvider>
  );
};

export default Nav;
